/* tslint:disable */
/* eslint-disable */
/**
 * Client Signup API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { ManagerInfoPhoto } from './';
import {
    ManagerInfoPhotoFromJSON,
    ManagerInfoPhotoFromJSONTyped,
    ManagerInfoPhotoToJSON,
} from './';

/**
 * 
 * @export
 * @interface ManagerInfo
 */
export interface ManagerInfo {
    /**
     * 
     * @type {ManagerInfoPhoto}
     * @memberof ManagerInfo
     */
    photo?: ManagerInfoPhoto;
    /**
     * The email of the manager
     * @type {string}
     * @memberof ManagerInfo
     */
    email?: string;
    /**
     * The phone number of the manager
     * @type {string}
     * @memberof ManagerInfo
     */
    phoneNumber?: string;
    /**
     * The fullName name of the inviter
     * @type {string}
     * @memberof ManagerInfo
     */
    fullName?: string;
}

/**
 * Check if a given object implements the ManagerInfo interface.
 */
export function instanceOfManagerInfo(value: object): value is ManagerInfo {
    return true;
}

export function ManagerInfoFromJSON(json: any): ManagerInfo {
    return ManagerInfoFromJSONTyped(json, false);
}

export function ManagerInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ManagerInfo {
    if (json == null) {
        return json;
    }
    return {
        
        'photo': json['photo'] == null ? undefined : ManagerInfoPhotoFromJSON(json['photo']),
        'email': json['email'] == null ? undefined : json['email'],
        'phoneNumber': json['phoneNumber'] == null ? undefined : json['phoneNumber'],
        'fullName': json['fullName'] == null ? undefined : json['fullName'],
    };
}

export function ManagerInfoToJSON(value?: ManagerInfo | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'photo': ManagerInfoPhotoToJSON(value['photo']),
        'email': value['email'],
        'phoneNumber': value['phoneNumber'],
        'fullName': value['fullName'],
    };
}

